// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"1779":"bazaar-visual-v1/ico-help-minor","3326":"sentry","8760":"bukalapak/bazaar-visual"}[chunkId] || chunkId) + "-" + __webpack_require__.h() + ".js";
};